import { useState } from "react";
import { TESTIMONIALS } from "@/constants/testIds";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";
import { Button } from "@/components/ui/button";

const quotes = [
  {
    quote: "After my husband passed, the death benefit was wired to me in nine days. Faith Family Finance walked me through every form. I will never forget their kindness.",
    name: "Maria G.",
    role: "Whole Life policyholder, Tampa FL",
  },
  {
    quote: "We were quoted three times less here than the big online company. Same A-rated carrier. Same coverage. A real human on the phone. I tell every neighbor.",
    name: "Daniel & Priya R.",
    role: "Term Life policyholders, Austin TX",
  },
  {
    quote: "I'm 71 and never thought I could qualify. They found me a final expense policy with no medical exam. My grandchildren won't ever have to worry.",
    name: "Beverly W.",
    role: "Final Expense policyholder, Asheville NC",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const prev = () => setI((p) => (p - 1 + quotes.length) % quotes.length);
  const next = () => setI((p) => (p + 1) % quotes.length);
  const t = quotes[i];

  return (
    <section
      data-testid={TESTIMONIALS.section}
      className="py-16 sm:py-24 lg:py-32 bg-[hsl(40_28%_94%)] relative"
    >
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-10 text-center">
        <p className="overline mb-8">In their own words</p>

        <div className="flex justify-center gap-1 mb-8">
          {[...Array(5)].map((_, idx) => (
            <Star key={idx} className="h-5 w-5 fill-accent text-accent" strokeWidth={1.5} />
          ))}
        </div>

        <blockquote
          key={i}
          className="animate-fade-up font-serif italic text-2xl sm:text-4xl lg:text-5xl leading-[1.2] tracking-tight text-primary"
        >
          &ldquo;{t.quote}&rdquo;
        </blockquote>

        <div className="mt-12">
          <p className="font-medium text-foreground">{t.name}</p>
          <p className="text-sm text-muted-foreground">{t.role}</p>
        </div>

        <div className="mt-12 flex items-center justify-center gap-4">
          <Button
            variant="outline"
            size="icon"
            onClick={prev}
            className="rounded-full h-11 w-11 border-border/70 bg-transparent hover:bg-muted"
            aria-label="Previous"
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <span className="text-xs tracking-[0.2em] uppercase text-muted-foreground">
            {String(i + 1).padStart(2, "0")} / {String(quotes.length).padStart(2, "0")}
          </span>
          <Button
            variant="outline"
            size="icon"
            onClick={next}
            className="rounded-full h-11 w-11 border-border/70 bg-transparent hover:bg-muted"
            aria-label="Next"
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </section>
  );
}
